import FilterTitle from './FilterTitle.css';

export default FilterTitle;
